import { render, staticRenderFns } from "./member-manage.vue?vue&type=template&id=b03058be"
import script from "./member-manage.vue?vue&type=script&lang=js"
export * from "./member-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports